import { CssBaseline } from '@mui/material'
import { RouterProvider } from 'react-router-dom'
import router from './routes'
import ThemeCustomization from './themes'

export function App() {
  return (
    <ThemeCustomization>
      <CssBaseline />
      <div data-testid='app-root'>
        <RouterProvider router={router} />
      </div>
    </ThemeCustomization>
  )
}
